import { render } from "./bottom.vue?vue&type=template&id=2c3c99b2&scoped=true"
const script = {}

import "./bottom.vue?vue&type=style&index=0&id=2c3c99b2&scoped=scoped&lang=css"
script.render = render
script.__scopeId = "data-v-2c3c99b2"

export default script